<template>
    <div class="relative">
        <page-header/>
        <div class="page page-1" id="page-1">
            <div class="background d-none d-md-block"></div>
            <div class="page-content">
                <div class="center">
                    <div class="container">
                        <div class="row align-items-center h-auto">
                            <div class="col-12 h-100">
                                <img class="logo" src="../../static/assets/images/logos/1x/LMP_logo.png" srcset="../../static/assets/images/logos/2x/LMP_logo@2x.png 2x, ../../static/assets/images/logos/3x/LMP_logo@3x.png 3x" />
                            </div>
                        </div>
                        <div class="row align-items-center h-auto">
                            <div class="col-12 description h-100">
                                A beautiful, free music player for iOS brought to you by the team at Livio.
                            </div>
                        </div>
                        <div class="row h-75">
                            <div class="row w-100 align-items-center no-gutters">
                                <div class="col-3 text-right h-100 d-none d-sm-block">
                                    <div class="row mh-75">
                                        <div class="col-12 align-items-top d-none d-md-block h-100">
                                            <img class="side-image" src="../../static/assets/images/misc/1x/confetti_left.png" srcset="../../static/assets/images/misc/2x/confetti_left@2x.png 2x, ../../static/assets/images/misc/3x/confetti_left@3x.png 3x" />
                                        </div>
                                    </div>
                                    <div class="row h-25 align-items-end">
                                        <div class="col-12 h-100">
                                            <a href="https://smartdevicelink.com"><img class="page-image" src="../../static/assets/images/logos/1x/sdl_logo.png" srcset="../../static/assets/images/logos/2x/sdl_logo@2x.png 2x, ../../static/assets/images/logos/3x/sdl_logo@3x.png 3x" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col h-100">
                                    <img class="page-image" src="../../static/assets/images/UI_mock/1x/Home.png" srcset="../../static/assets/images/UI_mock/2x/Home@2x.png 2x, ../../static/assets/images/UI_mock/3x/Home@3x.png 3x" />
                                </div>
                                <div class="col-3 text-left h-100 d-none d-sm-block">
                                    <div class="row mh-75">
                                        <div class="col-12 align-items-top d-none d-md-block h-100">
                                            <img class="side-image" src="../../static/assets/images/misc/1x/confetti_right.png" srcset="../../static/assets/images/misc/2x/confetti_right@2x.png 2x, ../../static/assets/images/misc/3x/confetti_right@3x.png 3x" />
                                        </div>
                                    </div>
                                    <div class="row h-25 align-items-end">
                                        <div class="col-12 h-100">
                                            <router-link to="/download/ios"><img class="page-image" src="../../static/assets/images/logos/1x/appstore_icon.png" srcset="../../static/assets/images/logos/2x/appstore_icon@2x.png 2x, ../../static/assets/images/logos/3x/appstore_icon@3x.png 3x" /></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center h-auto d-sm-none">
                            <div class="col-4 ml-auto h-100">
                                <a href="https://smartdevicelink.com"><img class="page-image" src="../../static/assets/images/logos/1x/sdl_logo.png" srcset="../../static/assets/images/logos/2x/sdl_logo@2x.png 2x, ../../static/assets/images/logos/3x/sdl_logo@3x.png 3x" /></a>
                            </div>
                            <div class="col-4 mr-auto h-100">
                                <router-link to="/download/ios"><img class="page-image" src="../../static/assets/images/logos/1x/appstore_icon.png" srcset="../../static/assets/images/logos/2x/appstore_icon@2x.png 2x, ../../static/assets/images/logos/3x/appstore_icon@3x.png 3x" /></router-link>
                            </div>
                        </div>
                        <div class="row align-items-center h-auto">
                            <div class="col-12 pin-bottom h-100">
                                <i class="fa fa-fw fa-3x white fa-angle-down"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-2" id="page-2">
            <div class="page-content">
                <div class="center">
                    <div class="container">
                        <div class="row align-items-center h-25">
                            <div class="col-12 description">
                                Livio Music brings your Apple Music, iTunes, podcasts, and local music into one app.
                            </div>
                        </div>
                        <div class="row align-items-center h-75">
                            <div class="row align-items-center">
                                <div class="col-4 col-sm-3 text-right h-100">
                                    <img class="page-image apple-to-livio" src="../../static/assets/images/misc/1x/AppleMusictoLMP.png" srcset="../../static/assets/images/misc/2x/AppleMusictoLMP@2x.png 2x, ../../static/assets/images/misc/3x/AppleMusictoLMP@3x.png 3x" />
                                </div>
                                <div class="col-8 col-sm-9 col-md-6 h-100">
                                    <img class="page-image" src="../../static/assets/images/UI_mock/1x/NowPlaying.png" srcset="../../static/assets/images/UI_mock/2x/NowPlaying@2x.png 2x, ../../static/assets/images/UI_mock/3x/NowPlaying@3x.png 3x" />
                                </div>
                                <div class="col-3 d-none d-md-block h-100">
                                    <dl class="steps text-left">
                                        <dt>Step 1</dt>
                                        <dd><router-link to="/download/ios">Download</router-link> the app from the app store.</dd>
                                        <dt>Step 2</dt>
                                        <dd>Agree to the terms and conditions and privacy policy.</dd>
                                        <dt>Step 3</dt>
                                        <dd>Import your media from your favorite Apple services.</dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-3" id="page-3">
            <div class="page-content">
                <div class="center">
                    <div class="container">
                        <div class="row align-items-center h-25">
                            <div class="col-12 description">
                                Livio Music works in a variety of vehicles.
                            </div>
                        </div>
                        <div class="row align-items-center h-75">
                            <div class="row align-items-center no-gutters">
                                <div class="col-3 text-right d-none d-md-block h-100">
                                    <img class="page-image" src="../../static/assets/images/logos/1x/sdl_logo_big.png" srcset="../../static/assets/images/logos/2x/sdl_logo_big@2x.png 2x, ../../static/assets/images/logos/3x/sdl_logo_big@3x.png 3x" />
                                </div>
                                <div class="col-8 col-md-6 h-100">
                                    <img class="page-image" src="../../static/assets/images/UI_mock/1x/SDL.png" srcset="../../static/assets/images/UI_mock/2x/SDL@2x.png 2x, ../../static/assets/images/UI_mock/3x/SDL@3x.png 3x" />
                                </div>
                                <div class="col-4 col-md-3 text-left h-100">
                                    <div class="phone-to-car">
                                        <span class="graphic-header">Supported in vehicles equipped with SmartDeviceLink.</span>
                                        <img class="page-image" src="../../static/assets/images/misc/1x/phone_car_illo.png" srcset="../../static/assets/images/misc/2x/phone_car_illo@2x.png 2x, ../../static/assets/images/misc/3x/phone_car_illo@3x.png 3x" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-4" id="page-4">
            <div class="page-content">
                <div class="center wide">
                    <div class="container">
                        <div class="row align-items-center h-25">
                            <div class="col-12 description">
                                Themes designed to match your mood.
                            </div>
                        </div>
                        <div class="row align-items-center h-75">
                            <div class="row align-items-center no-gutters">
                                <div class="col-2 text-right">
                                    Livio Light
                                </div>
                                <div class="col-8 h-100 d-block d-md-none">
                                    <img class="page-image" src="../../static/assets/images/UI_mock/1x/MobileThemes.png" srcset="../../static/assets/images/UI_mock/2x/MobileThemes@2x.png 2x, ../../static/assets/images/UI_mock/3x/MobileThemes@3x.png 3x" />
                                </div>
                                <div class="col-4 h-100 d-none d-md-block">
                                    <img class="page-image" src="../../static/assets/images/UI_mock/1x/HomePlaying.png" srcset="../../static/assets/images/UI_mock/2x/HomePlaying@2x.png 2x, ../../static/assets/images/UI_mock/3x/HomePlaying@3x.png 3x" />
                                </div>
                                <div class="col-4 h-100 d-none d-md-block">
                                    <img class="page-image" src="../../static/assets/images/UI_mock/1x/HomePlayingDark.png" srcset="../../static/assets/images/UI_mock/2x/HomePlayingDark@2x.png 2x, ../../static/assets/images/UI_mock/3x/HomePlayingDark@3x.png 3x" />
                                </div>
                                <div class="col-2 text-left">
                                    Livio Dark
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-5" id="page-5">
            <div class="page-content center">
                <div class="center wide">
                    <div class="container">
                        <div class="row align-items-center h-25">
                            <div class="col-12 description">
                                Download our media kit for more information,<br/>screenshots, and assets.
                            </div>
                        </div>
                        <div class="row align-items-center h-75">
                            <div class="col-12">
                                <div class="mk-content mx-auto no-gutters">
                                    <img class="mediakit" src="../../static/assets/images/misc/1x/Mediakit.png" srcset="../../static/assets/images/misc/2x/Mediakit@2x.png 2x, ../../static/assets/images/misc/3x/Mediakit@3x.png 3x" />
                                    <div class="row align-items-center square h-100">
                                        <div class="col-12">
                                        </div>
                                    </div>
                                    <a href="../../static/downloads/LMP_MediaKit.pdf" target="_blank" class="row align-items-center download">
                                        <div class="col-12">
                                            Download
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <page-footer/>
    </div>
</template>

<script>
import Header from './shared/Header.vue'
import Footer from './shared/Footer.vue'
export default {
    data () {
        return {
        }
    },
    components: {
        "page-header": Header,
        "page-footer": Footer
    }
}
</script>



// WEBPACK FOOTER //
// Home.vue?e5dc1ede